<script setup lang="ts">
import { useCheckoutStore } from "./checkoutStore";
import { storeToRefs } from "pinia";
import { ref, computed } from "vue";

const checkoutStore = useCheckoutStore();
const { applyCoupon, removeCoupon } = checkoutStore;
const { couponCode, discountAmount, discountPercent } =
    storeToRefs(checkoutStore);

const manuallyExpanded = ref(false);

// Auto-expand when there's a coupon code, or when manually expanded
const isExpanded = computed(() => {
    return couponCode.value || manuallyExpanded.value;
});

const toggle = () => {
    manuallyExpanded.value = !manuallyExpanded.value;
};
</script>
<template>
    <div>
        <button
            @click="toggle"
            :aria-expanded="isExpanded"
            aria-controls="couponCode"
            class="text-blue-700 text-sm font-bold"
            :hidden="isExpanded"
        >
            + Add Coupon Code
        </button>
        <div id="couponCode" :hidden="!isExpanded" tabindex="-1">
            <div v-if="discountPercent === 0">
                <label
                    for="coupon"
                    class="block text-sm font-semibold text-gray-700"
                    >Coupon Code</label
                >
                <div class="mt-1 flex gap-2">
                    <div
                        class="relative flex items-stretch flex-grow focus-within:z-10"
                    >
                        <input
                            type="text"
                            id="coupon"
                            name="coupon"
                            class="focus:ring-blue-500 focus:border-blue-500 block font-mono uppercase w-full sm:text-sm border-gray-300"
                            autocomplete="off"
                            v-model="couponCode"
                            @keydown="
                                (e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        applyCoupon(couponCode);
                                    }
                                }
                            "
                        />
                    </div>
                    <button
                        type="button"
                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                        v-on:click="() => applyCoupon(couponCode)"
                    >
                        <span>Apply</span>
                    </button>
                </div>
            </div>
            <div v-if="discountPercent > 0">
                <label
                    for="coupon"
                    class="block text-sm font-medium text-gray-700 pl-2"
                    >Coupon Code</label
                >
                <div class="mt-1 flex gap-2">
                    <div
                        class="relative flex items-stretch flex-grow focus-within:z-10"
                    >
                        <input
                            disabled
                            type="text"
                            id="coupon"
                            class="focus:ring-blue-500 focus:border-blue-500 block bg-gray-100 text-gray-500 font-mono uppercase w-full rounded-none rounded-l-md sm:text-sm border-gray-300"
                            v-model="couponCode"
                        />
                        <div
                            class="absolute flex items-center justify-center right-0 h-full pr-2"
                        >
                            <div
                                class="py-1 px-2 rounded-lg text-xs border bg-green-50 font-bold text-green-700"
                                v-text="discountPercent + '%'"
                            ></div>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                        v-on:click="removeCoupon"
                    >
                        <span>&times; Remove</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
